import React from 'react'
import NavBarHome from '../../components/NavBar/NavBarHome'
import Footer from '../../components/Footer/Footer'
import HeroSection from './HeroSection'
import ProgramHighlights from './ProgramHighlights'
import InfosPratiques from './InfosPratiques'
import ProgramDétaillé from './ProgramDétaillé'
import AgeGroups from './AgeGroups'

function SummerMakerStages() {
   return (
      <div className="pt-[92px] flex flex-col min-h-screen overflow-x-hidden">
         <NavBarHome />

         <div className="w-full font-sans text-dark-1">
            <HeroSection />
            <ProgramHighlights />
            <AgeGroups />
            <InfosPratiques />
            <ProgramDétaillé />
         </div>

         {/* Footer */}
         <section id="footer">
            <Footer
               logo={"/Logo NextMaker.png"}
               bgColor="bg-[#140342]"
               textColor="text-white"
               borderColor="border-gray-400/20"
            />
         </section>
      </div>
   )
}

export default SummerMakerStages